import { object } from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import React from "react";

import RightArrow from "../../../atoms/icons/right-arrow";
import ScrollSnap from "../../../molecules/ScrollSnap";

import "./slideshow-element.m.css";

const Slideshow = ({ element }) => {
  const handlePageView = () => {
    window.dataLayer.push({
      event: "slideShow"
    });
  };

  const children = element["story-elements"].map((item, index) => (
    <div key={index}>
      <div id="slidehow-image_wrapper">
        <figure className="blank-story-image" styleName="qt-image-16x9">
          <ResponsiveImage
            slug={item["image-s3-key"]}
            metadata={item["image-metadata"]}
            aspectRatio={[16, 9]}
            defaultWidth={480}
            widths={[250, 480, 640]}
            imgParams={{ auto: ["format", "compress"], fmt: "webp" }}
            alt={item["image-attribution"] || item.title || ""}
          />
        </figure>
      </div>
      {item.title && (
        <div styleName="scroll-caption-wrapper">
          <figcaption styleName="caption" dangerouslySetInnerHTML={{ __html: item.title }} />
          {item["image-attribution"] && (
            <span styleName="attribute" dangerouslySetInnerHTML={{ __html: `${item["image-attribution"]}` }} />
          )}
        </div>
      )}
    </div>
  ));

  return (
    <div styleName="wrapper">
      <ScrollSnap leftArrow={<RightArrow />} rightArrow={<RightArrow />} handleNextClick={handlePageView}>
        {children}
      </ScrollSnap>
    </div>
  );
};

Slideshow.propTypes = {
  element: object
};

export default Slideshow;
